/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ReschedulePenaltyStatus {
  APPLIED = 'applied',
  SLOT_LOST = 'slot_lost',
}
